import { KaboodleToaster } from "components/common";
import KaboodleForm from "components/Forms/KaboodleForm";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { usePatchMSAByIdMutation } from "services/msa-api";
import type { MSADataType } from "types/DataTypes";
import type { InputFields } from "types/FormTypes";

import { getCMSSubmissionFields } from "./cms-submission";
import SubmissionBuilderGate from "./submission-builder/SubmissionBuilder";

export type CardConfig = {
  cardName: string;
  cardNumber: number;
  style: {
    width: string;
    backgroundColor: string;
  };
  componentProps: Record<string, unknown>;
  fields: FieldConfig[];
};

export type FieldConfig = {
  label: string;
  component: InputFields;
  apiField: string;
  componentProps: Record<string, unknown>;
};

type CMSSubmissionFormFields = {
  has_been_submitted_to_cms: boolean;
  date_requested: string;
  due_date: string;
  date_approved: string;
  date_submitted: string;
  notice_of_submit_delivered_on: string;
  case_control_number: string;
};

type CMSSubmissionProps = {
  msa: MSADataType;
};

const CMSSubmission = ({ msa }: CMSSubmissionProps) => {
  const methods = useForm<CMSSubmissionFormFields>();
  const [patchMsaById] = usePatchMSAByIdMutation();

  const handleSave = async (field: string, value: unknown) => {
    try {
      await patchMsaById({
        msaId: msa.id.toString(),
        data: { [field]: value },
      }).unwrap();
    } catch (error) {
      console.error("Failed to update field:", error);
      KaboodleToaster.error("Failed to update field");
    }
  };

  useEffect(() => {
    if (msa) {
      methods.reset({
        has_been_submitted_to_cms: msa.has_been_submitted_to_cms || false,
        date_requested: msa.date_requested || "",
        date_approved: msa.date_approved || "",
        date_submitted: msa.date_submitted || "",
        notice_of_submit_delivered_on: msa.notice_of_submit_delivered_on || "",
        case_control_number: msa.case_control_number || "",
      });
    }
  }, [msa, methods]);

  return (
    <div className="swim-column">
      {/* feature-flagged; renders nothing when the switch is off or the
          service type is not MSA / Amended Review */}
      <SubmissionBuilderGate msa={msa} />
      <KaboodleForm
        cards={getCMSSubmissionFields()}
        onSave={handleSave}
        classNames="max-content-w"
      />
    </div>
  );
};

export default CMSSubmission;
